import { Component, Inject, Input, OnChanges, OnDestroy, Optional, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';

import { SisRadioOption } from '../../../../sis/sis-radio-group/sis-radio-group.component';
import { SisSelectOption } from '../../../../sis/sis-select/sis-select.component';

@Component({
  selector: 'app-agricola-pep-screen',
  templateUrl: './agricola-pep-screen.component.html',
  styleUrls: ['./agricola-pep-screen.component.css'],
  standalone: false
})
export class AgricolaPepScreenComponent implements OnChanges, OnDestroy {
  @Input() group!: FormGroup;
  private subscriptions = new Subscription();

  readonly yesNoOptions: SisRadioOption[] = [
    { label: 'Si', value: 'si' },
    { label: 'No', value: 'no' }
  ];

  readonly fundsOptions: SisSelectOption[] = [
    { label: 'NEGOCIO PROPIO', value: 'NEGOCIO PROPIO' },
    { label: 'OTRO', value: 'OTRO' }
  ];

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) data: { group?: FormGroup } | null,
    @Optional() private readonly dialogRef: MatDialogRef<AgricolaPepScreenComponent> | null
  ) {
    if (data?.group) {
      this.group = data.group;
      this.bindPepChanges();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['group']) {
      this.bindPepChanges();
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  get isPepSelected(): boolean {
    return this.group?.get('isPep')?.value === 'si';
  }

  get isRelativePepSelected(): boolean {
    return this.group?.get('relativePep')?.value === 'si';
  }

  get isDialog(): boolean {
    return !!this.dialogRef;
  }

  close(): void {
    this.dialogRef?.close();
  }

  private bindPepChanges(): void {
    this.subscriptions.unsubscribe();
    this.subscriptions = new Subscription();

    if (!this.group) {
      return;
    }

    this.subscriptions.add(this.group.get('isPep')?.valueChanges.subscribe(value => {
      if (value === 'no') {
        this.clearPepFields();
      }
    }) || new Subscription());

    this.subscriptions.add(this.group.get('relativePep')?.valueChanges.subscribe(value => {
      if (value === 'no') {
        this.clearRelativePepFields();
      }
    }) || new Subscription());
  }

  private clearPepFields(): void {
    this.group.patchValue({
      position: '',
      startDate: null,
      endDate: null,
      pepNationality: '',
      pepDocumentType: '',
      pepDocumentNumber: '',
      fundsOrigin: ''
    });
  }

  private clearRelativePepFields(): void {
    this.group.patchValue({
      relativePosition: '',
      relativeStartDate: null,
      relativeEndDate: null,
      relativeNationality: '',
      relativeDocumentType: '',
      relativeDocumentNumber: '',
      relativeFundsOrigin: '',
      relativeIncomeSource: '',
      relativeProjectedIncome: ''
    });
  }
}
